import { Stack } from "@mui/material";
import { useField } from "formik";

import { BodyTextM, cs, HeadingM, useIsTablet } from "@repo/ui";
import AmountInput from "./AmountInput";
import PossibleTaxSaving from "./PossibleTaxSaving";
import { possibleTaxSavingFormulaAfterNovel, yearlyStateContributionFormulaAfterNovel } from "@repo/logic";

const PortalResult = ({
	monthlyContribution,
}: {
	monthlyContribution: number;
}) => {
	const isTablet = useIsTablet();

	const [field] = useField("amount");
	const monthlyStateContributionAfterNovel =
		yearlyStateContributionFormulaAfterNovel(field.value) / 12;
	const currentMonthlyStateContributionAfterNovel =
		yearlyStateContributionFormulaAfterNovel(monthlyContribution) / 12;
	const currentPossibleTaxSaving =
		possibleTaxSavingFormulaAfterNovel(monthlyContribution);

	return (
		<Stack direction={isTablet ? "row" : "column"} spacing={isTablet ? 0 : 6}>
			<Stack
				sx={{ width: isTablet ? "50%" : "100%", mr: isTablet ? "3%" : 0 }}
				spacing={2}
			>
				<HeadingM sx={{ mb: 4, color: "primary.main" }}>
					{cs.pensionCalculator.result.currentSetting}:
				</HeadingM>
				<Stack spacing={5}>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						sx={{ minHeight: 42 }}
					>
						<BodyTextM mb={0} withoutScale strong>
							{cs.pensionCalculator.result.currentSavings}:
						</BodyTextM>
						<HeadingM mb={0}>
							{monthlyContribution}
							{"\u00A0"}Kč
						</HeadingM>
					</Stack>
					<Stack spacing={3}>
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
						>
							<BodyTextM sx={{ maxWidth: 250 }}>
								{cs.pensionCalculator.result.stateContributionDescription}
							</BodyTextM>
							<HeadingM mb={0}>
								{currentMonthlyStateContributionAfterNovel}
								{"\u00A0"}Kč
							</HeadingM>
						</Stack>
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
						>
							<BodyTextM>
								{cs.pensionCalculator.result.possibleTaxSaving}
							</BodyTextM>
							<HeadingM mb={0}>
								{currentPossibleTaxSaving}
								{"\u00A0"}Kč
							</HeadingM>
						</Stack>
					</Stack>
				</Stack>
			</Stack>
			<Stack
				sx={{ width: isTablet ? "50%" : "100%", mr: isTablet ? "3%" : 0 }}
				spacing={2}
			>
				<HeadingM sx={{ mb: 4, color: "primary.main" }}>
					{cs.pensionCalculator.result.resultAfterNovel}:
				</HeadingM>
				<Stack spacing={5}>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<BodyTextM mb={0} withoutScale strong>
							{cs.pensionCalculator.result.yourContribution}:
						</BodyTextM>
						<Stack direction="row" sx={{ alignItems: "center" }}>
							<AmountInput monthlyContribution={monthlyContribution} />
						</Stack>
					</Stack>
					<Stack spacing={3}>
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
						>
							<BodyTextM sx={{ maxWidth: 250 }}>
								{cs.pensionCalculator.result.stateContributionDescription}
							</BodyTextM>
							<HeadingM
								mb={0}
								sx={{
									color:
										field.value < monthlyContribution
											? "#E64415"
											: field.value === monthlyContribution
												? "#404040"
												: "#538B4C",
								}}
							>
								{monthlyStateContributionAfterNovel}
								{"\u00A0"}Kč
							</HeadingM>
						</Stack>
						<PossibleTaxSaving currentTaxAmount={currentPossibleTaxSaving} />
					</Stack>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default PortalResult;
